import {Component, inject, ViewEncapsulation} from '@angular/core'
import {MatButton} from '@angular/material/button'
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent
} from '@angular/material/dialog'
import {DomSanitizer, SafeHtml} from '@angular/platform-browser'

@Component({
  selector: 'spb-uc-report',
  templateUrl: './uc-report.component.html',
  styleUrls: ['./uc-report.component.scss'],
  imports: [MatDialogContent, MatDialogActions, MatButton, MatDialogClose],
  encapsulation: ViewEncapsulation.ShadowDom
})
export class UcReportComponent {
  public html: SafeHtml = ''
  private readonly sanitizer = inject(DomSanitizer)


  constructor() {
    const htmlAsString = inject(MAT_DIALOG_DATA)

    this.html = this.sanitizer.bypassSecurityTrustHtml(htmlAsString ?? `<span>Felaktigt svar från UC</span>`)
  }
}